import * as React from 'react'
import { type FilterTypes, filterBarStore, filterBarStore as store } from '../filter-bar.store'
import { CollectionSort } from '../../collection-sort'
import { Input } from '../../../shared'
import { observer } from 'mobx-react'
import './filter-bar-desktop.scss'
import { ProductMetafieldFilter } from '../../product-filter'

const FilterBarDesktop: React.FC = () => {
  const capitalize = (str: string) => {
    if (typeof str !== 'string' || str.length === 0) {
      return str
    }

    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const shouldDisplaySelectedFilters = Object.values(filterBarStore.selectedFiltersV2).some((filter) => filter.length > 0)

  return (
    <>
      <div className='filter-bar-desktop'>
        <div className='filter-bar-desktop__view-options'>
          <div className='filter-bar-desktop__wrapper'>
            <ProductMetafieldFilter type='preference' />
            <ProductMetafieldFilter type='protein' />
            <ProductMetafieldFilter type='cuisine' />
            <ProductMetafieldFilter type='dietary_preferences' />
            <Input type='text' placeholder='Search the menu...' classNames='filter-bar-desktop__search' onChange={store.handleSearchFilter} />
          </div>
          <CollectionSort /> 
        </div>
      </div>
      {shouldDisplaySelectedFilters && (
        <div className='filter-bar-display-options'>
          {Object.entries(filterBarStore.selectedFiltersV2).map(([type, filters]) => {
            if (filters.length > 0) {
              return filters.map((filter: string) => (
                <span key={filter} className='filter-bar-display-options__item'>
                  {`${capitalize(type)}: ${filter}`}
                  <span className='close' onClick={() => filterBarStore.removeSelectedFilter(type as keyof FilterTypes, filter)}>
                    &#10005;
                  </span>
                </span>
              ))
            }
          })}
          <span className='remove-all' onClick={() => filterBarStore.resetSelectedFiltersV2()}>
            Remove all
          </span>
        </div>
      )}
    </>
  )
}

export default observer(FilterBarDesktop)
